<!-- nls-rework\src\app\components\loan\make-payment\make-payment.component.html -->
@if (loan(); as loan) {
  <mat-card appearance="outlined">
    <mat-card-content>
      <form class="payment-form" [formGroup]="paymentForm" (ngSubmit)="submitPayment()" appPopulateForm="paymentForm">
        <mat-stepper #stepper [linear]="true" [orientation]="stepperOrientation()" [(selectedIndex)]="currentStep">
          <!-- Payment details step -->
          <mat-step [stepControl]="paymentForm" label="Payment Details" [editable]="!paymentConfirmed">
            <!-- Payment Summary -->
            <section class="payment-summary">
              <h2>Payment Summary</h2>

              <div class="payment-amounts">
                <div class="payment-field strong">
                  <strong>Total Due Amount: {{ loan.nextPaymentDueAmount | currency }}</strong>
                </div>

                <div class="payment-field">
                  <span>Total Due (including late fees and other charges):
                    {{
                    (loan.nextPaymentDueAmount || 0) + (loan.lateCharges || 0) + (loan.otherCharges || 0) | currency
                  }}</span>
                </div>
              </div>
            </section>

            <!-- Payment Method -->
            <!-- <section class="payment-method">
            <h2>Payment Method</h2>

            <div class="payment-method-option">
              <span>Bank Account</span>
            </div>
          </section> -->

          <!-- Payment Methods -->
          @if (paymentForm.get('paymentType')?.value === 'oneTime') {
            <section class="payment-method">
              <h2>Payment Method</h2>
              <mat-radio-group formControlName="paymentMethod" class="payment-method-radio-group">
                <mat-radio-button value="bank">Bank Account (ACH) - No Convenience Fee on ACH payments.</mat-radio-button>
                <mat-radio-button value="card">Debit Card - Credit Cards are not allowed.</mat-radio-button>
              </mat-radio-group>
              <p>Debit Cards are locked to One-Time payments only.</p>
            </section>
          }

          <!-- Payment Info -->
          <section class="payment-info">
            <h2>Payment Info</h2>

            <div class="payment-options">
              <mat-radio-group formControlName="paymentType" class="payment-type-radio-group">
                <div class="payment-option">
                  <mat-radio-button value="oneTime">One-Time Payment</mat-radio-button>
                </div>

                <!-- Show Autopay options ONLY when not paying by card -->
                @if (paymentForm.get('paymentMethod')?.value !== 'card') {
                  <div class="payment-option">
                    <mat-radio-button value="autoPay">Autopay - Billing Amount</mat-radio-button>
                  </div>
                  <div class="payment-option">
                    <mat-radio-button value="recurringPayment">Autopay - Fixed Recurring Payment</mat-radio-button>
                  </div>
                }
              </mat-radio-group>
            </div>
          </section>

          <!-- Bank Account Details -->
          @if (
            paymentForm.get('paymentMethod')?.value === 'bank' ||
            paymentForm.get('paymentType')?.value !== 'oneTime'
            ) {
            <section class="bank-account-details">
              <h2>Bank Account Details</h2>
              <div class="bank-account-options">
                <!-- ONE‑TIME PAYMENT: radios + dropdown + Add New -->
                @if (paymentForm.get('paymentType')?.value === 'oneTime') {
                  <div class="one-time-account-row">
                    <!-- Use Existing / Use New radios -->
                    <mat-radio-group formControlName="bankAccountOption" class="bank-account-radio-group">
                      <div class="existing-option">
                        <mat-radio-button value="existing">Use Existing</mat-radio-button>
                        <!-- Existing‑bank dropdown -->
                        <mat-form-field appearance="fill" class="existing-dropdown">
                          <mat-label>Select a saved bank</mat-label>
                          <mat-select formControlName="existingBankId"
                            [disabled]="paymentForm.get('bankAccountOption')?.value === 'new'">
                            @for (b of banks; track b) {
                              <mat-option [value]="b.ACHWalletID">
                                {{ b.bankName }} ••••{{ ("" + b.AccountNumber).slice(-2) }}
                              </mat-option>
                            }
                          </mat-select>
                          @if (paymentForm.get('existingBankId')?.hasError('required')) {
                            <mat-error>
                              Please choose one of your saved accounts
                            </mat-error>
                          }
                        </mat-form-field>
                        <!-- Add New button -->
                        <button mat-stroked-button type="button" class="add-new-btn" (click)="openManagePaymentMethods()">
                          Add New
                        </button>
                      </div>
                      <mat-radio-button value="new">Use New</mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <!-- New‑account fields (only for one‑time) -->
                  @if (
                    paymentForm.get('bankAccountOption')?.value === 'new' &&
                    paymentForm.get('paymentType')?.value === 'oneTime'
                    ) {
                    <div class="new-account-fields">
                      <div class="form-field-wrapper">
                        <mat-form-field>
                          <mat-label>Routing Number</mat-label>
                          <input matInput formControlName="routingNumber" maxlength="9" />
                          @if (isBankLoading()) {
                            <mat-spinner matSuffix diameter="20"></mat-spinner>
                          }
                          @if (bankName()) {
                            <mat-hint>{{ bankName() }}</mat-hint>
                          }
                          @if (paymentForm.get('routingNumber')?.hasError('required')) {
                            <mat-error>
                              Routing number is required
                            </mat-error>
                          }
                          @if (paymentForm.get('routingNumber')?.hasError('pattern')) {
                            <mat-error>
                              Enter a valid routing number (9 digits)
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="form-field-wrapper">
                        <mat-form-field appearance="fill">
                          <mat-label>Account Number</mat-label>
                          <input matInput formControlName="accountNumber" />
                          @if (paymentForm.get('accountNumber')?.hasError('required')) {
                            <mat-error>
                              Account number is required
                            </mat-error>
                          }
                          @if (paymentForm.get('accountNumber')?.hasError('invalidAccountNumber')) {
                            <mat-error>
                              {{ invalidAccountNumberMsg }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="form-field-wrapper">
                        <mat-form-field appearance="fill">
                          <mat-label>Account Number Confirmation</mat-label>
                          <input matInput formControlName="accountNumberConfirm" />
                          @if (paymentForm.get('accountNumberConfirm')?.hasError('required')) {
                            <mat-error>
                              Account number confirmation is required
                            </mat-error>
                          }
                          @if (paymentForm.get('accountNumberConfirm')?.hasError('mismatch')) {
                            <mat-error>
                              Account numbers do not match
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <mat-form-field>
                        <mat-label>Account Type</mat-label>
                        <mat-select formControlName="accountType">
                          <mat-option [value]="AccountType.Checking">Checking</mat-option>
                          <mat-option [value]="AccountType.Savings">Savings</mat-option>
                        </mat-select>
                        @if (paymentForm.get('accountType')?.hasError('required')) {
                          <mat-error>
                            Account type is required
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  }
                }
                <!-- AUTO‑PAY (At Billing or Recurring): existing only + Add New -->
                @if (paymentForm.get('paymentType')?.value !== 'oneTime') {
                  <!-- lock to existing -->
                  <input type="hidden" formControlName="bankAccountOption" value="existing" />
                  <div class="existing-row">
                    <mat-form-field appearance="fill" class="existing-dropdown">
                      <mat-label>Select a saved bank</mat-label>
                      <mat-select formControlName="existingBankId">
                        @for (b of banks; track b) {
                          <mat-option [value]="b.ACHWalletID">
                            {{ b.bankName }} ••••{{ ("" + b.AccountNumber).slice(-2) }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (paymentForm.get('existingBankId')?.hasError('required')) {
                        <mat-error>
                          Please choose one of your saved accounts
                        </mat-error>
                      }
                    </mat-form-field>
                    <button mat-stroked-button type="button" class="add-new-btn"
                      (click)="paymentForm.patchValue({ bankAccountOption: 'new' }); openManagePaymentMethods()">
                      Add New
                    </button>
                  </div>
                }
              </div>
            </section>
          }

          <!-- NEW: Debit Card Details (One-Time only, not saved) -->
          @if (
            paymentForm.get('paymentType')?.value === 'oneTime' &&
            paymentForm.get('paymentMethod')?.value === 'card'
            ) {
            <section class="card-details">
              <h2>Debit Card Details</h2>
              <div class="card-fields compact-grid">
                <mat-form-field appearance="fill" class="full-row">
                  <mat-label>Name On Card</mat-label>
                  <input matInput formControlName="cardName" id="ccname" autocomplete="ccname" inputmode="text"
                    maxlength="55" placeholder="Enter the name as it appears on the card" />
                  @if (paymentForm.get('cardName')?.invalid && paymentForm.get('cardName')?.touched) {
                    <mat-error>
                      Enter a valid card name
                    </mat-error>
                  }
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Card Number</mat-label>
                  <input matInput formControlName="cardNumber" id="ccnumber" autocomplete="ccnumber" inputmode="numeric"
                    maxlength="23" placeholder="0000 0000 0000 0000" />
                  @if (paymentForm.get('cardNumber')?.invalid && paymentForm.get('cardNumber')?.touched) {
                    <mat-error>
                      Enter a valid card number
                    </mat-error>
                  }
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Expiration</mat-label>
                  <input matInput formControlName="cardExpiry" id="ccexpiry" autocomplete="ccexpiry" inputmode="numeric"
                    placeholder="MM/YY" />
                  @if (paymentForm.get('cardExpiry')?.invalid && paymentForm.get('cardExpiry')?.touched) {
                    <mat-error>
                      Use MM/YY
                    </mat-error>
                  }
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>CVV</mat-label>
                  <input matInput formControlName="cardCvv" id="cccvv" autocomplete="cccvv" inputmode="numeric"
                    maxlength="4" />
                  @if (paymentForm.get('cardCvv')?.invalid && paymentForm.get('cardCvv')?.touched) {
                    <mat-error>
                      Enter a valid CVV
                    </mat-error>
                  }
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Billing Zip Code</mat-label>
                  <input matInput formControlName="cardZip" inputmode="numeric" />
                  @if (paymentForm.get('cardZip')?.invalid && paymentForm.get('cardZip')?.touched) {
                    <mat-error>
                      Billing Zip Code is required
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <p class="note mt-3">
                We’ll authorize and capture this one-time payment. Your card won’t be saved. Fee 3.50%
              </p>
            </section>
          }

          @if (paymentForm.get('paymentType')?.value) {
            <section class="payment-details">
              <h2>Payment Details</h2>
              <!-- One‑Time fields -->
              @if (paymentForm.get('paymentType')?.value === 'oneTime') {
                <div class="one-time-options">
                  @if (paymentForm.get("paymentType")?.value === "oneTime") {
                    <div class="one-time-options">
                      <!-- replace the inline style wrapper with a class -->
                      <div class="amount-row form-field-wrapper">
                        <mat-form-field class="amount-field">
                          <mat-label>Payment Amount</mat-label>
                          @if (paymentForm.get("amount")?.value || amountInputFocused) {
                            <span matTextPrefix>$&nbsp;</span>
                          }
                          <input matInput type="number" formControlName="amount" id="payment-amount-input" min="0"
                            [placeholder]="(loan.nextPaymentDueAmount | currency: '' : '') ?? '0'"
                            (focus)="amountInputFocused = true" (blur)="amountInputFocused = false" />
                          <mat-error>
                            @if (paymentForm.get("amount")?.touched && paymentForm.get("amount")?.hasError("required")) {
                              Amount is required
                            } @else if (
                              paymentForm.get("amount")?.touched && paymentForm.get("amount")?.hasError("min")
                              ) {
                              Amount must be greater than 0
                            }
                          </mat-error>
                        </mat-form-field>
                        <!-- Fee Badge -->
                        @if (paymentForm.get('paymentMethod')?.value === 'card') {
                          <div class="fee-badge no-grow"
                            matTooltip="3.5% convenience fee for debit cards" aria-label="Debit card fee">
                            <div class="fee-label">Fee (3.5%)</div>
                            <div class="fee-value">
                              {{ cardFeeAmount() | currency }}
                            </div>
                          </div>
                        }
                        <!-- the total badge -->
                        @if (paymentForm.get('paymentMethod')?.value === 'card') {
                          <div class="total-with-fee no-grow">
                            <div class="total-label">Total (incl. 3.5% fee)</div>
                            <div class="total-value">
                              {{ cardTotal() | currency }}
                            </div>
                          </div>
                        }
                      </div>
                      <!-- Hide date picker for one-time CARD payments -->
                      @if (paymentForm.get('paymentMethod')?.value !== 'card') {
                        <div class="form-field-wrapper">
                          <mat-form-field>
                            <mat-label>Payment Date</mat-label>
                            <input matInput [matDatepicker]="oneTimePicker" formControlName="oneTimeDate" [min]="today" />
                            <mat-datepicker-toggle matIconSuffix [for]="oneTimePicker"></mat-datepicker-toggle>
                            <mat-datepicker #oneTimePicker></mat-datepicker>
                            <mat-error>
                              @if (
                                paymentForm.get("oneTimeDate")?.touched &&
                                paymentForm.get("oneTimeDate")?.hasError("required")
                                ) {
                                Payment date is required
                              }
                            </mat-error>
                          </mat-form-field>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              <!-- Autopay Billing Notice -->
              <div>
                @if (paymentForm.get('paymentType')?.value === 'autoPay') {
                  <div class="">
                    <p>You will pay the regular payment amount.</p>
                  </div>
                }
                <div>
                  <strong>Notice:</strong>
                  Billing Autopay will not automatically cover any past-due balance. If your account is past due,
                  additional payments are required to bring the account current. Late fees or other charges may continue
                  to apply until the account is up to date.
                </div>
              </div>
              <!-- Fixed Recurring fields -->
              @if (paymentForm.get('paymentType')?.value === 'recurringPayment') {
                <div class="recurring-options">
                  @if (paymentForm.get("paymentType")?.value === "recurringPayment") {
                    <div class="recurring-options">
                      <div class="form-field-wrapper">
                        <mat-form-field>
                          <mat-label>Payment Amount</mat-label>
                          @if (paymentForm.get("recurringAmount")?.value || amountInputFocused) {
                            <span matTextPrefix>$&nbsp;</span>
                          }
                          <input matInput type="number" formControlName="recurringAmount" min="0"
                            [placeholder]="(loan.nextPaymentDueAmount | currency: '' : '') ?? '0'"
                            (focus)="amountInputFocused = true" (blur)="amountInputFocused = false" />
                          <mat-error>
                            @if (
                              paymentForm.get("recurringAmount")?.touched &&
                              paymentForm.get("recurringAmount")?.hasError("required")
                              ) {
                              Amount is required
                            } @else if (
                              paymentForm.get("recurringAmount")?.touched &&
                              paymentForm.get("recurringAmount")?.hasError("min")
                              ) {
                              Amount must be greater than 0
                            }
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="form-field-wrapper">
                        <mat-form-field>
                          <mat-label>Frequency</mat-label>
                          <mat-select formControlName="frequency">
                            <mat-option value="weekly">Weekly</mat-option>
                            <mat-option value="monthly">Monthly</mat-option>
                          </mat-select>
                          <mat-error>
                            @if (
                              paymentForm.get("frequency")?.touched && paymentForm.get("frequency")?.hasError("required")
                              ) {
                              Frequency is required
                            }
                          </mat-error>
                        </mat-form-field>
                      </div>
                      @if (paymentForm.get("frequency")?.value === "weekly") {
                        <div class="form-field-wrapper">
                          <mat-form-field>
                            <mat-label>Day of Week</mat-label>
                            <mat-select formControlName="dayOfWeek">
                              <mat-option value="monday">Monday</mat-option>
                              <mat-option value="tuesday">Tuesday</mat-option>
                              <mat-option value="wednesday">Wednesday</mat-option>
                              <mat-option value="thursday">Thursday</mat-option>
                              <mat-option value="friday">Friday</mat-option>
                              <mat-option value="saturday">Saturday</mat-option>
                              <mat-option value="sunday">Sunday</mat-option>
                            </mat-select>
                            <mat-error>
                              @if (
                                paymentForm.get("dayOfWeek")?.touched &&
                                paymentForm.get("dayOfWeek")?.hasError("required")
                                ) {
                                Day of week is required
                              }
                            </mat-error>
                          </mat-form-field>
                        </div>
                      }
                      @if (paymentForm.get("frequency")?.value === "monthly") {
                        <div class="form-field-wrapper">
                          <mat-form-field>
                            <mat-label>Start Date</mat-label>
                            <input matInput [matDatepicker]="monthlyPicker" formControlName="monthlyStartDate" [min]="today" />
                            <mat-datepicker-toggle matIconSuffix [for]="monthlyPicker"></mat-datepicker-toggle>
                            <mat-datepicker #monthlyPicker></mat-datepicker>
                            <mat-error>
                              @if (
                                paymentForm.get("monthlyStartDate")?.touched &&
                                paymentForm.get("monthlyStartDate")?.hasError("required")
                                ) {
                                Start date is required
                              }
                            </mat-error>
                          </mat-form-field>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </section>
          }

          <mat-card appearance="outlined" class="bank-verification-notice">
            <mat-card-content>
              <!-- Disclaimers -->
              <p class="disclaimer">
                <strong>Disclaimer:</strong> Payments may take 1–3 business days to withdraw. Please make sure your
                account has enough funds. If not, a Non-Sufficient Funds (NSF) fee may apply.
              </p>

              @if (paymentForm.get('paymentType')?.value === 'autoPay') {
                <p class="disclaimer">
                  <strong>Disclaimer:</strong> Your billing amount may change if you make new purchases or your balance
                  updates.
                </p>
              }

              @if (paymentForm.get('paymentType')?.value === 'recurringPayment') {
                <p class="disclaimer">
                  <strong>Disclaimer:</strong> The “Autopay - Fixed Recurring Payment” payment schedule will apply a
                  fixed payment amount. If you make additional purchases or your balance changes, you'll need to update
                  the payment amount manually to avoid underpayment.
                </p>
              }

              <!-- Card-specific disclaimer -->
              @if (
                paymentForm.get('paymentMethod')?.value === 'card' &&
                paymentForm.get('paymentType')?.value === 'oneTime'
                ) {
                <p class="disclaimer">
                  Debit card payments post immediately. This is a one-time authorization and capture. Your debit card
                  details aren't stored by Transend.
                </p>
              }

              @if (paymentForm.get('bankAccountOption')?.value !== 'existing') {
                <p class="disclaimer">
                  If this is the first time using this account for a payment, please allow for an additional 24 hours of
                  processing time to verify the account. Account verification is only required on the very first usage
                  of the account. Previously used accounts are not subject to additional processing time for
                  verification.
                </p>
              }

              <p class="disclaimer">
                If you've selected a <strong>one-time payment</strong>, you authorize Transend to initiate a one-time
                electronic funds transfer from your bank listed above in the amount and on the date specified.
              </p>

              <p class="disclaimer">
                If you have selected Set Up Autopay, please review the Autopay Enrollment Authorization: "By selecting
                <strong>Autopay</strong>, you authorize recurring ACH payments from your designated account. If
                <strong>three consecutive payments fail or are returned</strong>, your Autopay authorization will be
                <strong>automatically cancelled</strong>. You remain responsible for ensuring timely payments on your
                account."
              </p>

              <a class="disclaimer" (click)="openAutopayDisclosure()">See Autopay Authorization Disclosure</a>

              <br />

              <a class="disclaimer" (click)="openErrorResolutionDisclosure()">See Error Resolution Disclosure</a>
            </mat-card-content>
          </mat-card>

          <div class="action-buttons">
            <button mat-raised-button type="button" id="review-payment-btn" (click)="onReviewClicked(stepper)"
              [disabled]="isProcessingPayment">
              Review Payment
            </button>
          </div>
        </mat-step>

        <!-- Review step -->
        <mat-step label="Review" [completed]="paymentConfirmed" [editable]="!paymentConfirmed">
          @if (paymentForm.valid) {
            <div class="review-details">
              <h3>Review Payment Details</h3>

              @if (paymentForm.get("paymentType")?.value === "oneTime") {
                <p>Payment Type: One-Time Payment</p>
                <p>
                  Amount: {{ reviewAmount() | currency }}
                  @if (paymentForm.get('paymentMethod')?.value === 'card') {
                    <small>
                      (includes {{ cardFeeAmount() | currency }} card fee)
                    </small>
                  }
                </p>
                <p>Date: {{ reviewDate() | date: "shortDate" }}</p>
              } @else if (paymentForm.get("paymentType")?.value === "autoPay") {
                <p>Payment Type: Autopay - Billing Amount</p>
                <p>Amount: Regular Payment Amount</p>
              } @else if (paymentForm.get("paymentType")?.value === "recurringPayment") {
                <p>Payment Type: Autopay - Fixed Recurring Amount</p>
                <p>
                  Amount:
                  {{ $safeNavigationMigration(paymentForm.get("recurringAmount")?.value) | currency }}
                </p>
                <p>
                  Frequency:
                  {{ $safeNavigationMigration(paymentForm.get("frequency")?.value) | titlecase }}
                </p>
                @if (paymentForm.get("frequency")?.value === "weekly") {
                  <p>
                    Day of Week:
                    {{ $safeNavigationMigration(paymentForm.get("dayOfWeek")?.value) | titlecase }}
                  </p>
                } @else if (paymentForm.get("frequency")?.value === "monthly") {
                  <p>
                    Start Date:
                    {{ $safeNavigationMigration(paymentForm.get("monthlyStartDate")?.value) | date: "shortDate" }}
                  </p>
                }
              }

              <p>Payment Method: {{ reviewMethodLabel() }}</p>

              <!-- Show bank-only review details -->
              @if (paymentForm.get('paymentMethod')?.value === 'bank') {
                @if (paymentForm.get("bankAccountOption")?.value === "new") {
                  <p>
                    Account Number: ****
                    {{ paymentForm.get("accountNumber")?.value?.slice(-4) }}
                  </p>
                  <p>
                    Account Type:
                    {{ $safeNavigationMigration(paymentForm.get("accountType")?.value) | titlecase }}
                  </p>
                } @else {
                  <p>Using Existing Bank Account</p>
                }
              }

              <!-- Show card-only review details (masked last4) -->
              @if (paymentForm.get('paymentMethod')?.value === 'card') {
                <p>Card: ••••{{ cardLast4() }}</p>
              }
            </div>

            <div class="action-buttons">
              <button mat-button matStepperPrevious type="button" id="back-btn" [disabled]="isProcessingPayment">
                Back
              </button>
              <button mat-flat-button color="primary" type="submit" id="submit-payment-btn"
                [disabled]="isProcessingPayment">
                Submit Payment
              </button>
            </div>
            @if (paymentForm.get('paymentMethod')?.value === 'card') {
              <!-- Add bubble styling to this paragraph -->
              <p class="bubble">
                By clicking the Submit Payment button the cardholder is authorizing a one-time payment for the amount
                shown above and acknowledges that the payment cannot be cancelled once processed.
              </p>
            }
          }
        </mat-step>

        <!-- Confirmation step -->
        <mat-step label="Confirmation">
          <div class="confirmation">
            <!-- Use this success message for the bank, but for debit card use Your payment has been successfully processed. -->
            <h3>Payment Submitted</h3>
            @if (paymentForm.get("paymentMethod")?.value === "bank") {
              <p>Your payment has been successfully scheduled.</p>
            } @else {
              <p>Your payment has been successfully processed.</p>
            }

            @if (
              paymentForm.get("paymentType")?.value === "autoPay" ||
              paymentForm.get("paymentType")?.value === "recurringPayment"
              ) {
              <p>Auto Pay has been set up for your account.</p>
            }

            <button mat-flat-button color="primary" routerLink="/loan/{{ loan.number }}" type="button">Done</button>
          </div>
        </mat-step>
      </mat-stepper>
    </form>
  </mat-card-content>
</mat-card>
}